import { Input } from "@headlessui/react";
import clsx from "clsx";
import { INPUT_CLASS } from "../tableStyles";

type Cell = { key: string; label: string; type?: "text" | "number" };

/** Spelled out, not interpolated -- Tailwind's JIT cannot see a built class name. */
const COLS: { [n: number]: string } = {
  1: "grid-cols-1",
  2: "grid-cols-2",
  3: "grid-cols-3",
  4: "grid-cols-4",
};

/**
 * Min / max / step (and optionally unit) on one row. Always rebuilds the whole
 * object from state -- patching by index is what produces sparse arrays in RTDB.
 */
export default function RangeEditor({
  label,
  value,
  onChange,
  cells,
}: {
  label: string;
  value: any;
  onChange: (v: any) => void;
  cells: Cell[];
}) {
  const v = value ?? {};
  return (
    <div className="space-y-2">
      <div className="text-sm font-medium opacity-60">{label}</div>
      <div className={clsx("grid gap-2", COLS[cells.length] ?? "grid-cols-3")}>
        {cells.map((c) => (
          <div key={c.key}>
            <div className="text-[10px] uppercase opacity-40 mb-1">{c.label}</div>
            <Input
              type={c.type === "text" ? "text" : "number"}
              value={v[c.key] ?? ""}
              onChange={(e) => {
                const raw = e.target.value;
                const parsed =
                  c.type === "text"
                    ? raw || undefined
                    : raw === ""
                    ? undefined
                    : Number(raw);
                onChange({ ...v, [c.key]: parsed });
              }}
              className={clsx(INPUT_CLASS, "py-1 px-2")}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
